(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-spec-details"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productSpecDetailsInit) return;
    window.__productSpecDetailsInit = true;

    var DURATION = 250;
    var EASING = 'ease-in-out';
    var running = new WeakMap();

    document.addEventListener('click', function (event) {
      var summary = event.target.closest && event.target.closest('.product-spec-details-acc__summary');
      if (!summary) return;

      var details = summary.parentElement;
      var body = details.querySelector('[data-psd-body]');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!body || typeof body.animate !== 'function' || reduce) return; /* native toggle */

      event.preventDefault();

      var prev = running.get(details);
      var wasClosing = details.classList.contains('is-closing');
      var startHeight = details.open ? body.getBoundingClientRect().height : 0;
      var opening = !details.open || wasClosing;

      if (prev) { prev.onfinish = null; prev.cancel(); }

      if (opening) {
        details.classList.remove('is-closing');
        details.open = true;
        var endHeight = body.scrollHeight;
        body.style.overflow = 'hidden';
        var a = body.animate(
          { height: [startHeight + 'px', endHeight + 'px'] },
          { duration: DURATION, easing: EASING }
        );
        running.set(details, a);
        a.onfinish = function () { running.delete(details); body.style.overflow = ''; };
      } else {
        details.classList.add('is-closing');
        body.style.overflow = 'hidden';
        var b = body.animate(
          { height: [startHeight + 'px', '0px'] },
          { duration: DURATION, easing: EASING }
        );
        running.set(details, b);
        b.onfinish = function () {
          details.open = false;
          details.classList.remove('is-closing');
          body.style.overflow = '';
          running.delete(details);
        };
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
